import type { CSSProperties } from 'react';
import type { Client } from '../data/types';
import { HEALTH, PLAN, STATUS } from '../data/helpers';

/** Brand-tinted monogram avatar — each client reads at a glance. */
export function Avatar({ client, size = 38 }: { client: Client; size?: number }) {
  const style = { width: size, height: size, '--av': client.accent } as CSSProperties;
  return (
    <span className="rs-av" style={style} aria-hidden="true">
      {client.mono}
    </span>
  );
}

export function StatusChip({ status }: { status: Client['status'] }) {
  const s = STATUS[status];
  return <span className={'rs-chip st-' + s.cls}>{s.label}</span>;
}

export function PlanChip({ plan }: { plan: Client['plan'] }) {
  const p = PLAN[plan];
  return <span className={'rs-chip pl-' + p.cls}>{p.label}</span>;
}

export function HealthDot({ health, withLabel = false }: { health: Client['health']; withLabel?: boolean }) {
  const h = HEALTH[health];
  return (
    <span className={'rs-health h-' + h.cls} title={h.label}>
      <i />
      {withLabel && <span>{h.label}</span>}
    </span>
  );
}
